export default "Golf & Fun Park opened in 2015.";